import { Link } from "react-router-dom";
import CartQualityControl from "providers/QualityControlComponent/CartQualityControl";
import MuiCheckbox from "./MuiCheckbox";
import type { Store } from "./cart.types";
import { useWishlist } from "hooks/useWishlist";

interface Badge {
    src: string;
    alt?: string;
}

interface Product {
    id: number;
    code: string;
    name: string;
    link: string;
    image: string;
    pack: string;
    badges?: string[];
    discount?: number;
    price: string;
    originalPrice: string;
    max: number;
    qty: number;
    checked: boolean;
    important: boolean;
}

interface StoreCheckboxProps {
    store: Store;
    onToggle: (id: number) => void;
}

function StoreCheckbox({ store, onToggle }: StoreCheckboxProps) {
    return (
        <div className="styles_cartStoreTopAction__uW164">
            <MuiCheckbox
                checked={store.checked}
                indeterminate={
                    store.products.some(p => p.checked) &&
                    !store.products.every(p => p.checked)
                }
                onChange={() => onToggle(store.id)}
            />
        </div>
    );
}


export default function CartContainer({
    stores,
    toggleStore,
    toggleProduct,
    removeProduct,
    toggleImportant
}: {
    stores: Store[];
    toggleStore: (id: number) => void;
    toggleProduct: (storeId: number, productId: number) => void;
    removeProduct: (storeId: number, productId: number) => void;
    toggleImportant: (storeId: number, productId: number) => void;
}) {
    const { handleToggleWishlist, isInWishlist } = useWishlist();

    return (
        <div className="styles_cartList__KDbuH">

            {stores.map(store => (
                <div
                    key={store.id + 'cart'}
                    className="styles_cartStore__HcADi"
                    style={{ scrollMarginTop: "-330px" }}
                >

                    {/* ================= SHOP HEADER ================= */}
                    <div className="styles_cartStoreTop__0lxo2">

                        <a
                            className="styles_mobile_rootBase__8z7PQ styles_cartStoreTopInfo__1bkfc"
                            href={store.link}
                        >
                            {/* <div className="styles_cartStoreImage__VO14L w-[32px] h-[32px]">
                                <img
                                    alt="image product"
                                    src={store.logo}
                                    style={{
                                        display: "block",
                                        minWidth: "100%",
                                        minHeight: "100%",
                                        maxWidth: "100%",
                                        maxHeight: "100%"
                                    }}
                                />
                            </div> */}

                            <div className="styles_cartStoreHeading__9yeym">
                                {store.name}
                            </div>
                        </a>

                        {/* checkbox shop */}
                        < StoreCheckbox store={store} onToggle={toggleStore} />
                    </div>

                    {/* =============== PRODUCTS =============== */}
                    <div className="MuiBox-root css-j7qwjs">

                        {store.products.map((product: Product) => {
                                                       const hasDiscountPrice =
                                !!product.discount &&
                                !!product.originalPrice &&
                                product.originalPrice !== product.price;

                            const currentPrice = hasDiscountPrice ? product.price : product.originalPrice;
                            const normalPrice = hasDiscountPrice ? product.originalPrice : "";

                            return (
                            <div
                                key={product.id}
                                className="MuiPaper-root MuiCard-root styles_card__R7fh2 MuiPaper-elevation1 MuiPaper-rounded"
                                id={product.code}
                            >

                                <div className="styles_cardMain__PljwK MuiBox-root css-0">

                                    {/* ⭐ wishlist */}
                                    <div className="MarkItemAsImportant_cardWishList__eJZ3F MuiBox-root css-0">
                                        <span onClick={() => handleToggleWishlist(product.id)}>
                                            <img
                                                alt="sản phẩm quan tâm"
                                                src={
                                                    isInWishlist(product.id)
                                                        ? "https://cdn-web-next.thuocsi.vn/images/cart/active_important_icon.svg"
                                                        : "https://cdn-web-next.thuocsi.vn/images/cart/inactive_important_icon.svg"
                                                }
                                            />
                                        </span>
                                    </div>

                                    {/* 🖼 image */}
                                    <div className="styles_cardImage__9LN5I">
                                        <Link to={product.link}>
                                            <img
                                                alt={product.name}
                                                src={product.image}
                                                style={{ objectFit: "contain" }}
                                            />
                                        </Link>
                                    </div>

                                    {/* TEXT */}
                                    <div className="styles_cardDesc__TRPvz">

                                        <Link className="styles_cardTitle__OiNzy" to={product.link}>
                                            <span>{product.name}</span>
                                        </Link>

                                        <div className="styles_cardStore__PJfqT">
                                            {product.pack}
                                        </div>

                                        <div className="styles_cardBadges__Ucbc0">
                                            {product.badges?.map((b: string) => (
                                                <img key={b} src={b} alt="" />
                                            ))}
                                        </div>
                                    </div>

                                    {/* PRICE */}
                                        <div className="MuiCardContent-root styles_cardPrice__Bm_A0">
                                            {!!product.discount && (
                                                <div className="styles_cardPriceItem__RGJxx">
                                                    <div className="MuiChip-root styles_cardChip__m89pd MuiChip-sizeSmall">
                                                        <span className="MuiChip-label MuiChip-labelSmall">
                                                            -{product.discount}%
                                                        </span>
                                                    </div>
                                                </div>
                                            )}

                                            <div className="styles_cardPriceItem__RGJxx">
                                                <Link className="styles_cardCurrentPrice__U8eC2" to={product.link}>
                                                    <div>{currentPrice}đ</div>
                                                </Link>
                                            </div>

                                            {hasDiscountPrice && (
                                                <div className="styles_cardPriceItem__RGJxx MuiBox-root css-0">
                                                    <span className="styles_priceTextDiscount__F5k1h">{normalPrice}đ</span>
                                                </div>
                                            )}

                                            {/* <div className="styles_cardPriceItem__RGJxx MuiBox-root css-0">
                                                <span className="styles_priceTextDiscount__F5k1h">Giá đã giảm</span>
                                            </div> */}
                                        </div>

                                    {/* ACTION BAR */}

                                    <CartQualityControl productId={product.id} productName={product.name} />

                                    {/* remove + checkbox right */}
                                    <div className="MuiCardActions-root styles_cartEvents__rilD_ MuiCardActions-spacing">

                                        <div
                                            className="RemoveItemInCart_cartRemove__RraHh"
                                            title="Xóa Sản Phẩm"
                                            onClick={() => removeProduct(store.id, product.id)}
                                        >
                                            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.22866 14.3957C7.47053 14.3957 7.67683 14.3094 7.84756 14.1367C8.01829 13.9496 8.10366 13.7338 8.10366 13.4892V8.09352C8.0752 7.8777 7.97561 7.69784 7.80488 7.55396C7.63415 7.39568 7.43496 7.31655 7.20732 7.31655C6.9939 7.31655 6.80183 7.39568 6.6311 7.55396C6.46037 7.69784 6.36077 7.8777 6.33232 8.09352V13.4892C6.33232 13.7338 6.41768 13.9496 6.58841 14.1367C6.77337 14.3094 6.98679 14.3957 7.22866 14.3957ZM16.1067 3.60432H12.564V2.69784C12.564 2.20863 12.4431 1.76259 12.2012 1.35971C11.9594 0.942445 11.6321 0.61151 11.2195 0.366906C10.8211 0.122302 10.3801 0 9.89634 0H8.10366C7.61992 0 7.17175 0.122302 6.75915 0.366906C6.36077 0.61151 6.04065 0.942445 5.79878 1.35971C5.55691 1.76259 5.43598 2.20863 5.43598 2.69784V3.60432H1.89329C1.67988 3.63309 1.49492 3.73381 1.33841 3.90647C1.19614 4.07914 1.125 4.28058 1.125 4.51079C1.125 4.72662 1.19614 4.92086 1.33841 5.09352C1.49492 5.26619 1.67988 5.36691 1.89329 5.39568H2.76829V15.3022C2.76829 15.7914 2.88923 16.2374 3.1311 16.6403C3.37297 17.0576 3.69309 17.3885 4.09146 17.6331C4.50407 17.8777 4.95224 18 5.43598 18H12.564C13.0478 18 13.4888 17.8777 13.8872 17.6331C14.2998 17.3885 14.627 17.0576 14.8689 16.6403C15.1108 16.2374 15.2317 15.7914 15.2317 15.3022V5.39568H16.1067C16.3201 5.36691 16.498 5.26619 16.6402 5.09352C16.7967 4.92086 16.875 4.72662 16.875 4.51079C16.875 4.28058 16.7967 4.07914 16.6402 3.90647C16.498 3.73381 16.3201 3.63309 16.1067 3.60432ZM7.22866 2.69784C7.22866 2.45324 7.31402 2.2446 7.48476 2.07194C7.65549 1.89928 7.86179 1.81295 8.10366 1.81295H9.89634C10.1382 1.81295 10.3445 1.89928 10.5152 2.07194C10.686 2.2446 10.7713 2.45324 10.7713 2.69784V3.60432H7.22866V2.69784ZM13.439 15.3022C13.439 15.5468 13.3537 15.7554 13.1829 15.9281C13.0122 16.1007 12.8059 16.187 12.564 16.187H5.43598C5.19411 16.187 4.9878 16.1007 4.81707 15.9281C4.64634 15.7554 4.56098 15.5468 4.56098 15.3022V5.39568H13.439V15.3022ZM10.7713 14.3957C11.0132 14.3957 11.2195 14.3094 11.3902 14.1367C11.5752 13.9496 11.6677 13.7338 11.6677 13.4892V8.09352C11.6392 7.8777 11.5396 7.69784 11.3689 7.55396C11.1982 7.39568 10.999 7.31655 10.7713 7.31655C10.5579 7.31655 10.3659 7.39568 10.1951 7.55396C10.0244 7.69784 9.9248 7.8777 9.89634 8.09352V13.4892C9.89634 13.7338 9.98171 13.9496 10.1524 14.1367C10.3232 14.3094 10.5295 14.3957 10.7713 14.3957Z" fill="#494949"></path></svg>
                                        </div>

                                        <div
                                            className="SelectItem_cartCheckBox__FE9_K"
                                            title="Chọn Sản Phẩm"
                                        >
                                            <MuiCheckbox
                                                checked={product.checked}
                                                indeterminate={false}
                                                onChange={() => toggleProduct(store.id, product.id)}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            )}
                        )}
                    </div>

                    {/* FOOTER VOUCHER BAR */}
                    {/* <div className="MuiBox-root css-4r1lgk" style={{ margin: "16px" }}>
                        <div className="MuiBox-root css-axw7ok">
                            <img
                                alt="suggest icon"
                                src="https://cdn-web-next.thuocsi.vn/images/cart/suggest_voucher_icon.svg"
                            />
                            <div className="styles_suggestText__Li4Vi">
                                {store.voucherText}
                            </div>
                        </div>
                        <div className="styles_suggestButton__JgX7R MuiBox-root css-0">
                            <span> Mua thêm </span>
                            <svg className="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-vubbuv" focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="KeyboardArrowRightIcon">
                                <path d="M8.59 16.59 13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"></path>
                            </svg>
                        </div>
                    </div> */}

                </div >
            ))
            }
        </div >
    );
}
